import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API, { getCsrfToken, APICsrf } from "../../utils/api";

// Async Thunk to Fetch Contact Information
export const fetchContact = createAsyncThunk(
  "contactinformation/fetchContact",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.get(`/fetchcontact`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const sendContactMessage = createAsyncThunk(
  "contactinformation/sendMessage",
  async (formData, { rejectWithValue }) => {
    try {
      await getCsrfToken();
      const response = await APICsrf.post('/api/contactmessage', formData, {
        headers: {
            'X-XSRF-TOKEN': decodeURIComponent(
                document.cookie
                    .split('; ')
                    .find(row => row.startsWith('XSRF-TOKEN='))
                    ?.split('=')[1] || ''
            ),
        },
    });
      return response.data.message;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const fetchPdf = createAsyncThunk(
  "contactinformation/fetchPdf",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.get(`/fetchpdf`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

const contactSlice = createSlice({
  name: "contactinformation",
  initialState: {
    contact: null,
    contact_loading: false,
    contact_error: null,
    contact_success: null,
    pdf: null,
    pdf_loading: false,
    pdf_error: null,
    pdf_success: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContact.pending, (state) => {
        state.contact_loading = true;
      })
      .addCase(fetchContact.fulfilled, (state, action) => {
        state.contact_loading = false;
        state.contact = action.payload;
      })
      .addCase(fetchContact.rejected, (state, action) => {
        state.contact_loading = false;
        state.contact_error = action.payload;
      })
      .addCase(fetchPdf.pending, (state) => {
        state.pdf_loading = true;
      })
      .addCase(fetchPdf.fulfilled, (state, action) => {
        state.pdf_loading = false;
        state.pdf = action.payload;
      })
      .addCase(fetchPdf.rejected, (state, action) => {
        state.pdf_loading = false;
        state.pdf_error = action.payload;
      })
      // Send Contact Message
      .addCase(sendContactMessage.pending, (state) => {
        state.contact_loading = true;
        state.contact_success = null;
      })
      .addCase(sendContactMessage.fulfilled, (state, action) => {
        state.contact_loading = false;
        state.contact_success = action.payload;
      })
      .addCase(sendContactMessage.rejected, (state, action) => {
        state.contact_loading = false;
        state.contact_error = action.payload;
      });
  },
});

export default contactSlice.reducer;
